/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { When } from "react-if";
import { Modal, Text, theme } from "@nordcloud/gnui";

import { CopyText } from "./CopyText";
import { SecretState } from "./reducers";
import { text } from "./text";

type Props = {
  onClose: () => void;
  isOpen: boolean;
  data: SecretState;
};

export function ApiKeySuccessModal({ onClose, isOpen, data }: Props) {
  const { keyId, keySecret } = data;

  return (
    <Modal
      isOpen={isOpen}
      contentLabel={text.rotateApiKey.result.success}
      actions={[
        {
          order: 0,
          label: "Close",
          onAction: () => onClose(),
          severity: "high",
        },
      ]}
      onClose={() => onClose()}
    >
      <Text size="sm" color={theme.color.text.text02}>
        {text.rotateApiKey.result.warning}
      </Text>
      <When condition={keyId}>
        <div>ID:</div>
        <CopyText text={keyId} />
      </When>
      <When condition={keySecret}>
        <div>Secret:</div>
        <CopyText secure text={keySecret} />
      </When>
    </Modal>
  );
}
